import { render, staticRenderFns } from "./wasteInsulate_region.vue?vue&type=template&id=aeb53040&scoped=true&"
import script from "./wasteInsulate_region.vue?vue&type=script&lang=js&"
export * from "./wasteInsulate_region.vue?vue&type=script&lang=js&"
import style0 from "./wasteInsulate_region.vue?vue&type=style&index=0&id=aeb53040&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb53040",
  null
  
)

export default component.exports